package org.example.project.engineletter

import androidx.compose.runtime.Composable
import org.example.project.engineletter.layouts.PalettenkontoabschlussLayout
import org.example.project.engineletter.layouts.WAPalettenscheinLayout
import org.example.project.engineletter.layouts.WAQualitaetsdokumentationLayout
import org.example.project.engineletter.layouts.WAVorgangslogLayout
import org.example.project.engineletter.layouts.WEPalettenscheinLayout
import org.example.project.engineletter.layouts.WEProzessdokumentationLayout
import org.example.project.engineletter.layouts.WEQualitaetsdokumentationLayout
import org.example.project.engineletter.layouts.WEWareneingangsberichtLayout
import org.example.project.utils.All

const val LETTER_LAYOUT_PALSCHEIN_WE = "PALSCHEIN_WE"
const val LETTER_LAYOUT_PALSCHEIN_WA = "PALSCHEIN_WA"
const val LETTER_LAYOUT_DOKUMENTATION_WE = "DOKUMENTATION_WE"
const val LETTER_LAYOUT_DOKUMENTATION_WA = "DOKUMENTATION_WA"
const val LETTER_LAYOUT_QUALITAET_WE = "QUALITAET_WE"
const val LETTER_LAYOUT_QUALITAET_WA = "QUALITAET_WA"
const val LETTER_LAYOUT_QUALITAET_WE_BERICHT = "QUALITAET_WE_BERICHT"
const val LETTER_LAYOUT_PALETTENKONTOABSCHLUSS = "PALETTENKONTOABSCHLUSS"

@Composable
fun RenderYardLetter(
    rootElementId: String? = null,
    layoutKey: String,
    auftrag: All?,
    vorgangslog: List<All>,
    unternehmen: All,
    logoSrc: String,
    kontrollDefinitionen: List<All> = emptyList(),
    webKontrolle: All? = null,
    sideBySidePreview: Boolean = false,
    ausstellerSignatur: String = "",
    ausstellerName: String = "",
    fahrerSignatur: String = "",
    fahrerName: String = ""
) {
    val source = auftrag ?: All(auftragsart = if (layoutKey.endsWith("_WE")) "WE" else "WA")
    when (layoutKey) {
        LETTER_LAYOUT_PALSCHEIN_WE -> WEPalettenscheinLayout(
            rootElementId = rootElementId,
            auftrag = source,
            unternehmen = unternehmen,
            logoSrc = logoSrc,
            ausstellerSignatur = ausstellerSignatur,
            ausstellerName = ausstellerName,
            fahrerSignatur = fahrerSignatur,
            fahrerName = fahrerName
        )
        LETTER_LAYOUT_PALSCHEIN_WA -> WAPalettenscheinLayout(
            rootElementId = rootElementId,
            auftrag = source,
            unternehmen = unternehmen,
            logoSrc = logoSrc,
            ausstellerSignatur = ausstellerSignatur,
            ausstellerName = ausstellerName,
            fahrerSignatur = fahrerSignatur,
            fahrerName = fahrerName
        )
        LETTER_LAYOUT_DOKUMENTATION_WE -> WEProzessdokumentationLayout(
            rootElementId = rootElementId,
            auftrag = source,
            vorgangslog = vorgangslog,
            unternehmen = unternehmen,
            logoSrc = logoSrc,
            kontrollDefinitionen = kontrollDefinitionen
        )
        LETTER_LAYOUT_DOKUMENTATION_WA -> WAVorgangslogLayout(
            rootElementId = rootElementId,
            auftrag = source,
            vorgangslog = vorgangslog,
            unternehmen = unternehmen,
            logoSrc = logoSrc,
            kontrollDefinitionen = kontrollDefinitionen
        )
        LETTER_LAYOUT_QUALITAET_WE -> WEQualitaetsdokumentationLayout(
            rootElementId = rootElementId,
            auftrag = source,
            unternehmen = unternehmen,
            logoSrc = logoSrc,
            kontrollDefinitionen = kontrollDefinitionen
        )
        LETTER_LAYOUT_QUALITAET_WA -> WAQualitaetsdokumentationLayout(
            rootElementId = rootElementId,
            auftrag = source,
            unternehmen = unternehmen,
            logoSrc = logoSrc,
            kontrollDefinitionen = kontrollDefinitionen
        )
        LETTER_LAYOUT_QUALITAET_WE_BERICHT -> WEWareneingangsberichtLayout(
            rootElementId = rootElementId,
            auftrag = source,
            webKontrolle = webKontrolle ?: All(),
            unternehmen = unternehmen,
            logoSrc = logoSrc,
            sideBySidePreview = sideBySidePreview
        )
        LETTER_LAYOUT_PALETTENKONTOABSCHLUSS -> PalettenkontoabschlussLayout(
            rootElementId = rootElementId,
            auftrag = source,
            unternehmen = unternehmen,
            logoSrc = logoSrc
        )
    }
}
